import SVG from './rawSVG';

export default SVG;
